import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import { useGroupCollectionsList } from '@shared/api/lib/group/group';
import {
  GroupCollectionsListParams,
  PaginatedGroupCollectionListList,
} from '@shared/api/types';

/**
 * Paginated collections across the parent's selected child organizations.
 * Each row carries `numProducts` and `averageEmissionsPerKg` annotations.
 */
export const useGetGroupCollections = (params?: GroupCollectionsListParams) =>
  useGroupCollectionsList<PaginatedGroupCollectionListList>(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
    },
  });
